import { IUser } from './IUser';

export interface ISiteUser extends IUser {
  groupCount?: number;
  lastSignIn?: string; // not present if user hasn't signed into site before.
  siteRole: string;
  authenticationProviderId?: string; // not present unless server.isSiteSamlEnabled
  authSetting?: string; // (deprecated in favor of authenticationProviderId)
  notificationEnabled?: boolean;
  userImageUrl?: string; // not present if a user image doesn't exist for this site user
  idpConfigurationName?: string;
  idpConfigurationId?: string;
}

export let SiteUserAuthSetting = {
  Oidc: 'OIDC',
  Saml: 'SAML',
  Default: 'DEFAULT',
  TabId_with_MFA: 'TABID_WITH_MFA'
};
